<template>
  <div class="Trio-body-wrapper Trio-optimal-amount">
    <div v-if="hasProposal" class="Trio-content-row">
      <ul class="Trio-boxes-list">
        <li v-if="fixedProposal" class="Trio-box">
          <div class="Trio-box-wrapper">
            <div>
              <span class="Trio-epi">Tu casa a tipo fijo</span>
              <span class="Trio-amount"
                >{{ formatCurrency(fixedProposal.price)
                }}<sup class="Trio-asterix">*</sup></span
              >
            </div>
            <span class="Trio-small-text"
              >máximo a {{ fixedProposal.years }} años</span
            >
          </div>
        </li>
        <li v-if="variableProposal" class="Trio-box">
          <div class="Trio-box-wrapper">
            <div>
              <span class="Trio-epi">Tu casa a tipo variable</span>
              <span class="Trio-amount"
                >{{ formatCurrency(variableProposal.price)
                }}<sup class="Trio-asterix">*</sup></span
              >
            </div>
            <span class="Trio-small-text"
              >máximo a {{ variableProposal.years }} años</span
            >
          </div>
        </li>
      </ul>
      <div class="Trio-text-row">
        <p class="Trio-small-text">
          * A efectos informativos, calcula según la mejor oferta del mercado,
          los ingresos declarados y entrada aportada.
        </p>
      </div>
    </div>
    <no-results v-else></no-results>
    <div class="Trio-footer-row">
      <div class="Trio-footer-content">
        <div class="Trio-btn-row">
          <a v-if="hasProposal" @click="next" class="Trio-btn">Continuar</a>
          <a v-else @click="back" class="Trio-btn">Atrás</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "../store/index.js";
import noResults from "./NoResults.vue";

/* eslint-disable */

export default {
  name: "affordResults",
  components: { noResults },
  computed: {
    fixedProposal() {
      return Store.getters["mortgageAfford/fixedProposal"];
    },
    variableProposal() {
      return Store.getters["mortgageAfford/variableProposal"];
    },
    hasProposal() {
      return Store.getters["mortgageAfford/hasProposal"];
    },
  },
  methods: {
    openLink: function (url) {
      window.open(url, "_blank");
    },
    formatCurrency(value) {
      return value.toLocaleString("es-ES", {
        style: "currency",
        currency: "EUR",
        maximumSignificantDigits: 3,
      });
    },
    round(value, precision) {
      return round(value, precision);
    },
    next() {
      Store.commit("ui/SET_STEP", 3);
    },
    back() {
      Store.commit("ui/SET_STEP", 1);
    },
  },
};
</script>